import { onError } from "@apollo/client/link/error"
import { ConnectionLost } from "event-definitions"

export const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
    if (graphQLErrors?.length) {
        console.error(
            `[GraphQL error]: ${operation?.operationName ?? "unknown operation"}`,
            graphQLErrors.map((error) => error.message)
        )
    }
    if (networkError) {
        console.error(`[Network error]: ${operation?.operationName ?? "unknown operation"} ${networkError}`)
        ConnectionLost.raise()
    }
})
